module.exports = __webpack_public_path__ + "img/avantage-achete-en-ligne.d1861e9a.svg";